import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { adminAuthApi, getOpsToken, setOpsToken } from '../services/api';

export default function AdminLayout() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!getOpsToken()) {
      nav('/admin/login', { replace: true });
      return;
    }
    adminAuthApi.me()
      .then((res) => setUser(res.user))
      .catch(() => { setOpsToken(null); nav('/admin/login', { replace: true }); })
      .finally(() => setChecked(true));
  }, [nav]);

  const logout = () => { setOpsToken(null); nav('/admin/login'); };

  if (!checked) return <div className="container"><span className="spinner" /></div>;
  if (!user) return null;
  const isAdmin = user.profile === 'admin';

  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        <div style={{ padding: '4px 10px 16px', fontWeight: 700 }}>Fair Ops</div>
        <NavLink to="/admin" end>Dashboard</NavLink>
        <NavLink to="/admin/contacts">Contacts</NavLink>
        <NavLink to="/admin/quarantine">Quarantine</NavLink>
        {isAdmin ? <NavLink to="/admin/users">Users</NavLink> : null}
        <NavLink to="/admin/settings">Settings</NavLink>
        <div style={{ marginTop: 24, padding: '4px 10px', fontSize: 13 }}>
          Signed in as<br />
          <strong>{user.username}</strong><br />
          <span className="small" style={{ opacity: 0.7 }}>{user.profile}</span>
        </div>
        <button className="btn ghost small" onClick={logout} style={{ color: '#cbd5e1', marginTop: 10 }}>Log out</button>
      </nav>
      <main className="admin-main">
        <Outlet context={{ user, isAdmin }} />
      </main>
    </div>
  );
}
